export default __webpack_public_path__ + "static/lounge-7eb4f6d352fc0576d6682c14585f33a4.png";